import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	bannerText: {
		id: 'new-product-message-banner-text',
		defaultMessage: "{product} was only recently added and we're still tweaking the results.",
		description: 'Text for banner message',
	},
	dismissMessage: {
		id: 'new-product-message-banner-dismiss-message-button',
		defaultMessage: 'Dismiss',
		description: 'Message for button to dismiss the new product banner',
	},
});
